import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface F9460 {
  f9460_01: string;        // 員工代號 (PK part1, max 8)
  f9460_02: string;        // 獎金發放別代碼 (PK part2, max 10)
  f9460_10: string;        // 部門代號 (max 4)
  f9460_21: number;        // 獎金金額
  f9460_22: number;        // 代金
  f9460_91: string;        // 建立人員
  f9460_92: string | null; // 建立/修改日期
  f9460_93: string;        // 修改人員
}

export interface F9460WithRefs extends F9460 {
  f933_11: string;         // 獎金發放別名稱
  f933_12: string | null;  // 獎金發放日期
  f933_22: number;         // 稅率
  f106_11: string;         // 部門名稱
  tax: number;             // 稅額
  net_pay: number;         // 實發金額
}

export interface CreateRequest {
  f9460_01: string; // 員工代號
  f9460_02: string; // 獎金發放別代碼
  f9460_10: string; // 部門代號
  f9460_21: number; // 獎金金額
  f9460_22: number; // 代金
}

export interface UpdateRequest {
  f9460_10: string; // 部門代號
  f9460_21: number; // 獎金金額
  f9460_22: number; // 代金
}

export interface ListResponse {
  data: F9460[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// Composite key helper: empCode:bonusType
function compositeId(empCode: string, bonusType: string): string {
  return `${encodeURIComponent(empCode)}:${encodeURIComponent(bonusType)}`;
}

// ============================================================
// API methods
// ============================================================

export const pw9236f1Api = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/pw9236f1', { params });
    return res.data;
  },

  async get(empCode: string, bonusType: string): Promise<F9460WithRefs> {
    const res = await apiClient.get(`/api/pw9236f1/${compositeId(empCode, bonusType)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<F9460> {
    const res = await apiClient.post('/api/pw9236f1', data);
    return res.data;
  },

  async update(empCode: string, bonusType: string, data: UpdateRequest): Promise<F9460> {
    const res = await apiClient.put(`/api/pw9236f1/${compositeId(empCode, bonusType)}`, data);
    return res.data;
  },

  async delete(empCode: string, bonusType: string): Promise<void> {
    await apiClient.delete(`/api/pw9236f1/${compositeId(empCode, bonusType)}`);
  },
};
